var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1999 25.802C50.2967 23.8975 47.2101 23.8966 45.3056 25.7999C45.3049 25.8006 45.3041 25.8014 45.3033 25.802L39.0016 32.107L32.6999 25.802C30.7955 23.8975 27.7078 23.8975 25.8035 25.802C23.8992 27.7064 23.899 30.7941 25.8035 32.6984L32.1084 39.0003L25.8033 45.302C23.8989 47.2064 23.8989 50.2941 25.8033 52.1984C27.7078 54.1029 30.7955 54.1029 32.6998 52.1984L39.0016 45.8935L45.3033 52.1986C47.2078 54.103 50.2955 54.103 52.1998 52.1986C54.1042 50.2941 54.1042 47.2064 52.1998 45.3021L45.8949 39.0003L52.1999 32.6986C54.1044 30.7954 54.1053 27.7087 52.2021 25.8043C52.2013 25.8035 52.2007 25.8028 52.1999 25.802Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78C60.5391 78 78 60.5391 78 39C77.9767 17.4705 60.5295 0.0233086 39 0ZM39 68.25C22.8456 68.25 9.75 55.1544 9.75 39C9.75 22.8456 22.8456 9.75 39 9.75C55.1544 9.75 68.25 22.8456 68.25 39C68.232 55.1469 55.1469 68.232 39 68.25Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e116103fdccd78d7d2ad0122810dba7a.svg";
export { ForwardRef as ReactComponent };